import { ExternalPageHeader } from '@/components/layout/external-page-header'
import { ResetPasswordForm } from '@/features/authentication/components/reset-password-form'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  return (
    <div className="relative flex min-h-screen flex-col bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 p-4 dark:from-slate-900 dark:via-emerald-900/20 dark:to-teal-900/20">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-emerald-500/20 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-teal-500/20 blur-3xl"></div>
        <div className="absolute left-1/4 top-1/3 h-64 w-64 rounded-full bg-cyan-500/10 blur-3xl"></div>
      </div>

      <ExternalPageHeader className="relative z-20 border-emerald-100/60 bg-white/80 dark:border-slate-800/60 dark:bg-slate-950/80" />

      <main className="relative z-10 flex flex-1 items-center justify-center px-4 py-10 text-slate-900 dark:text-slate-100">
        <div className="w-full max-w-md">
          <ResetPasswordForm />
          <footer className="mt-8 text-center text-xs text-slate-700 dark:text-slate-300">
            <p>© 2025 UIBFS. All rights reserved.</p>
          </footer>
        </div>
      </main>
    </div>
  )
}
